import React from 'react';
import DemoResultsPage from './demo/DemoResultsPage';
import FullResultsPage from './full/FullResultsPage';

const ResultSurfaceRouter = ({ resultMode = 'demo', scores, quizData, variantKey }) => {
    if (resultMode === 'full') {
        return <FullResultsPage scores={scores} quizData={quizData} />;
    }

    return <DemoResultsPage variantKey={variantKey} scores={scores} quizData={quizData} />;
};

export default ResultSurfaceRouter;
